var map = {
	"./ADA.svg": 871,
	"./BCH.svg": 872,
	"./BNB.svg": 873,
	"./BTC.svg": 874,
	"./CHZ.svg": 875,
	"./DASH.svg": 876,
	"./DOGE.svg": 877,
	"./DOT.svg": 878,
	"./ETC.svg": 879,
	"./ETH.svg": 880,
	"./EUR.svg": 881,
	"./GBP.svg": 882,
	"./LINK.svg": 883,
	"./LTC.svg": 884,
	"./MATIC.svg": 885,
	"./MKR.svg": 886,
	"./SHIB.svg": 887,
	"./SOL.svg": 888,
	"./TRX.svg": 889,
	"./UNI.svg": 890,
	"./USD.svg": 891,
	"./USDT.svg": 892,
	"./XLM.svg": 893,
	"./XMR.svg": 894,
	"./XRP.svg": 895,
	"./documents.svg": 896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 870;